import mapValues from 'lodash/mapValues'
import escapeStringRegexp from 'escape-string-regexp'

import { isEmptyString } from 'lib/detectType'

export const replaceUrlFromText = (text, matchedUrlArr) => {
  if (isEmptyString(text)) return ''
  // 유효한 URL만 필터링 및 중복 제거
  const seen = new Set()
  const filteredArr = matchedUrlArr.filter(campaign => {
    try {
      if (!campaign?.url) return false
      // URL 파싱 시도 (유효성만 체크, 변수에 할당)
      const _ = new URL(campaign.url) // eslint-disable-line no-unused-vars
      if (seen.has(campaign.url)) return false
      seen.add(campaign.url)
      return true
    } catch (e) {
      return false
    }
  })
  // path가 가장 긴 순서대로 정렬 (도메인 중복, 패스 다른 대응)
  const sortedArr = [...filteredArr].sort((a, b) => {
    try {
      const aPath = a?.url ? new URL(a.url).pathname : ''
      const bPath = b?.url ? new URL(b.url).pathname : ''
      return bPath.length - aPath.length
    } catch (e) {
      return 0
    }
  })
  sortedArr.forEach(campaign => {
    const url = campaign?.url
    const regexp = new RegExp(escapeStringRegexp(url), 'g')
    const keyword = `__{{ShortURL:CampaignId=${campaign?.campaignId}&URLIndex=${campaign?.urlIndex}}}__`
    text = text.replace(regexp, keyword)
  })
  return text
}

export const replaceUrlFromVariables = (variableValues, matchedUrlArr) => {
  const newVariableValues = mapValues(variableValues, recipientGroup => {
    return mapValues(recipientGroup, variables => {
      return variables.map(variable => {
        return {
          value: replaceUrlFromText(variable?.value, matchedUrlArr)
        }
      })
    })
  })
  return newVariableValues
}
export default {
  replaceUrlFromText,
  replaceUrlFromVariables
}
